import type { PermissionKey } from '@erp/shared';
import { Outlet } from 'react-router';

import { useCan } from '../lib/session.ts';
import { ForbiddenPage } from '../pages/status-pages.tsx';

/** Hides a section from users without the permission (the API still enforces it). */
export function RequirePermission({ permission }: { permission: PermissionKey }) {
  return useCan(permission) ? <Outlet /> : <ForbiddenPage />;
}
